/**
 * 烟雾趋势分析 — POST /api/produce/kanban/smoke-trend-analysis
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/smoke-trend-analysis'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchSmokeTrendAnalysis(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
